import * as types from "./types";
import { SettingsType } from "../../Models/ActionType";

export const setApplicationMounted: () => SettingsType = () => ({
  type: types.APP_MOUNTED,
});
